import { BaseComponent } from '../../base-component';
import { InstallmentPlanCalculatorSheet } from './installment-plan-calculator-sheet';
import { EventCallback } from '@otto-ec/global-resources/event-q-bus';
import { EFFECTIVE_PRICE_CHANGED_TOPIC, EffectivePriceChangeEvent, getRenderedEffectivePrice } from '../../price/client/effective-price';

const SHEET_OPEN = 'oc-open';

export class InstallmentPlanCalculatorComponent extends BaseComponent {
    public rootSelector = '.js_pdp_installment-plan-calculator';
    public sheetSelector = '#pdp_installment-plan-calculatorSheet';
    private priceChangeListener?: EventCallback<[EffectivePriceChangeEvent]> | null;
    private sheetOpenElement?: Element | null;
    private sheetOpenListener?: EventListener;

    public async onHtmlLoaded(): Promise<void> {
        if (this.priceChangeListener) {
            o_global.eventQBus.off(EFFECTIVE_PRICE_CHANGED_TOPIC, this.priceChangeListener);
        }
        if (this.sheetOpenElement && this.sheetOpenListener) {
            this.sheetOpenElement.removeEventListener(SHEET_OPEN, this.sheetOpenListener);
        }

        if (!this.isPresent()) {
            return;
        }

        const sheet = document.querySelector(this.sheetSelector);
        const installmentPlanCalculatorSheet = new InstallmentPlanCalculatorSheet();
        const variationId = this.getVariationId();
        const effectivePrice = getRenderedEffectivePrice();
        if (effectivePrice?.variationId === variationId) {
            installmentPlanCalculatorSheet.setEffectivePrice(effectivePrice.newPriceCents);
        }

        this.priceChangeListener = o_global.eventQBus.on(EFFECTIVE_PRICE_CHANGED_TOPIC, event => {
            if (event.variationId === variationId) {
                installmentPlanCalculatorSheet.setEffectivePrice(event.newPriceCents);
            }
        });
        this.sheetOpenElement = sheet;
        this.sheetOpenListener = event => installmentPlanCalculatorSheet.onSheetOpen(event);
        sheet?.addEventListener(SHEET_OPEN, this.sheetOpenListener);
    }
}
